module.exports = __webpack_public_path__ + "d13f7876c94369536d8dedc3f85adf7f.pdf";